// Keep this file as a backup and in case we need to add more variables in future
// The serviceUrl values will be overridden by specific values from systemInfo API during the startup time.
export const BLUEXP_CONFIG = {
    STAGING: {
        serviceUrl: 'https://preprod.console.bluexp.netapp.com'
    },
    DEV: {
        serviceUrl: 'https://staging.console.bluexp.netapp.com'
    },
    QA: {
        serviceUrl: 'https://staging.console.bluexp.netapp.com'
    },
    MAINQA: {
        serviceUrl: 'https://staging.console.bluexp.netapp.com'
    },
    PROD: {
        serviceUrl: 'https://console.bluexp.netapp.com',
    },
};
